import ChatMemberListItem from "../ChatMemberListItem/ChatMemberListItem";
import {Body} from "../typography";
import Margin from "../Margin/Margin";
import ListItem from "../list-item";

const ChatMemberList = ({ members, onRequestMute, loading }) => {
  const items = members || [];
  if (items.length === 0 && !loading)
    return <Margin horizontal={16}>
      <ListItem
        title="Não há nenhum membro para exibir."
        subtitle="Não encontrou o que procura? Tente atualizar a página ou entre em contato com o suporte."
        fadedSubtitle
        style={{paddingLeft: 0, paddingRight: 0}}
      />
  </Margin>;
  if (loading)
    return <div>
      {
        [1,2,3,4,5,6,7,8,9,10].map(() => <ChatMemberListItem loading={true} />)
      }
    </div>;
  return <div>
    {
      items.map(item => <ChatMemberListItem onRequestToggleMute={onRequestMute} name={item.name} status={item.status} internalId={item.internalId} mutedUntil={item.timeout} />)
    }
  </div>;
};

export default ChatMemberList;



// WEBPACK FOOTER //
// ./components/ChatMemberList/ChatMemberList.js